import AppState from '../../interfaces/app-state';

export const selectProductItems = (state: AppState) => state.product.items;
